import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import {
  GET_CONFIG_VERSION_API,
  getControllerConfigVersion,
} from '@/features/controller/configuration/endpoints/controllerConfiguration'
import type { ControllerConfigVersion } from '@/features/controller/configuration/types'
import type { UseQueryOptions } from '@/types/queries'

export type UseControllerConfigVersionQueryResult = Omit<UseQueryResult, 'data'> & {
  configVersion: ControllerConfigVersion | null
}

export function useControllerConfigVersionQuery(
  id: string,
  options?: UseQueryOptions<ControllerConfigVersion | null>,
): UseControllerConfigVersionQueryResult {
  const { data, ...queryResult } = useQuery<ControllerConfigVersion | null>({
    ...options,
    queryFn: () => getControllerConfigVersion(id),
    queryKey: [GET_CONFIG_VERSION_API, id],
  })

  return {
    ...queryResult,
    configVersion: data || null,
  }
}
